import Phaser from 'phaser';
import { frameMs } from 'tower/util';
import gameState from './state/game-state';

const FLASH_PALETTES = [1, 2, 0, 3];

export default class FlashableSprite extends Phaser.GameObjects.Sprite {
  protected _palette = 0;
  private flashTween: Phaser.Tweens.Tween | null = null;

  constructor(...args: ConstructorParameters<typeof Phaser.GameObjects.Sprite>) {
    super(...args);

    // Use a proxy to shift frame Y down based on the palette index whenever the frame is set
    const proxy = new Proxy(this, {
      set: (target: this, property: string | symbol, value: any) => {
        if (property === 'frame') {
          const frame = Object.create(value) as any;
          frame.setCutPosition(frame.cutX, frame.data.cut.y + this.palette * 16);
          return Reflect.set(target, property, frame);
        }

        return Reflect.set(target, property, value);
      },
    });
    this.anims.parent = proxy;
    return proxy;
  }

  get palette() {
    return this._palette;
  }

  set palette(value: number) {
    this._palette = value;
    this.frame = Object.create(this.frame);
    this.frame.setCutPosition(this.frame.cutX, (this.frame as any).data.cut.y + this.palette * 16);
  }

  flash(times: number) {
    if (this.flashTween !== null) {
      this.flashTween.destroy();
    }

    this.flashTween = this.scene.tweens.addCounter({
      from: 0,
      to: 4,
      duration: frameMs(8),
      repeat: times,
      onUpdate: (tween) => {
        if (gameState.getFlag('disableFlashing')) {
          this.palette = 2;
          return;
        }
        this.palette = FLASH_PALETTES[Math.floor(tween.getValue() as number) % FLASH_PALETTES.length];
      },
      onComplete: () => {
        this.palette = 0;
      },
    });

    return this.flashTween;
  }
}
